module.exports = __webpack_public_path__ + "img/seven-o'clock.eccc170a.png";